<script lang="ts">
    import { cn } from '$lib/utils/cn';

    export let progress = 0;
    export let className = '';
</script>

<div class={cn('bg-gray-400/50 fun-relative fun-h-[3px] fun-w-full fun-rounded-full', className)}>
    <div
        class="fun-absolute fun-left-0 fun-top-0 fun-h-full fun-rounded-full fun-bg-white fun-transition-all fun-duration-300 fun-ease-linear"
        style="width: {progress}%"
    />
</div>
